// Generated by generateKotlinApi; do not edit.
package io.github.erkko68.kolt.physics.collision.broadphase

import io.github.erkko68.kolt.*
import io.github.erkko68.kolt.capi.*
import io.github.erkko68.kolt.core.*
import io.github.erkko68.kolt.core.capi.*
import io.github.erkko68.kolt.geometry.*
import io.github.erkko68.kolt.geometry.capi.*
import io.github.erkko68.kolt.interop.*
import io.github.erkko68.kolt.math.*
import io.github.erkko68.kolt.objectstream.*
import io.github.erkko68.kolt.physics.*
import io.github.erkko68.kolt.physics.body.*
import io.github.erkko68.kolt.physics.body.capi.*
import io.github.erkko68.kolt.physics.capi.*
import io.github.erkko68.kolt.physics.character.*
import io.github.erkko68.kolt.physics.character.capi.*
import io.github.erkko68.kolt.physics.collision.*
import io.github.erkko68.kolt.physics.collision.broadphase.capi.*
import io.github.erkko68.kolt.physics.collision.capi.*
import io.github.erkko68.kolt.physics.collision.shape.*
import io.github.erkko68.kolt.physics.collision.shape.capi.*
import io.github.erkko68.kolt.physics.constraints.*
import io.github.erkko68.kolt.physics.constraints.capi.*
import io.github.erkko68.kolt.physics.constraints.constraintpart.*
import io.github.erkko68.kolt.physics.ragdoll.*
import io.github.erkko68.kolt.physics.ragdoll.capi.*
import io.github.erkko68.kolt.physics.softbody.*
import io.github.erkko68.kolt.physics.softbody.capi.*
import io.github.erkko68.kolt.physics.vehicle.*
import io.github.erkko68.kolt.physics.vehicle.capi.*
import io.github.erkko68.kolt.skeleton.*
import io.github.erkko68.kolt.skeleton.capi.*

/**
 * BroadPhaseLayerInterface implementation.
 * This defines a mapping between object and broadphase layers.
 * This implementation uses a simple table
 *
 * C++ `JPH::BroadPhaseLayerInterfaceTable`.
 */
class BroadPhaseLayerInterfaceTable internal constructor(internal val broadPhaseLayerInterfaceTableHandle: NativePointer, owned: Boolean = false) : BroadPhaseLayerInterface(JphBroadPhaseLayerInterfaceTable_asBroadPhaseLayerInterface(broadPhaseLayerInterfaceTableHandle), owned), AutoCloseable {
    constructor(numObjectLayers: Int, numBroadPhaseLayers: Int) : this(JphBroadPhaseLayerInterfaceTable_create(numObjectLayers, numBroadPhaseLayers), owned = true)

    override fun close() =
        closeOnce { JphBroadPhaseLayerInterfaceTable_destroy(broadPhaseLayerInterfaceTableHandle) }

    fun mapObjectToBroadPhaseLayer(objectLayer: Int, broadPhaseLayer: BroadPhaseLayer) =
        JphBroadPhaseLayerInterfaceTable_MapObjectToBroadPhaseLayer(broadPhaseLayerInterfaceTableHandle, objectLayer, broadPhaseLayer.value)
}
